import { forwardRef } from 'react';
import type { ClassValue } from 'clsx';
import clsx from 'clsx';

import type { IconProps } from '../../../components/icons';
import { Box } from '../Box/Box';

import * as styles from './styles.css';

export type Props = React.ButtonHTMLAttributes<HTMLButtonElement> &
  styles.Variants & {
    icon: React.ReactElement<IconProps>;
    cssClass?: ClassValue | ClassValue[];
  };

export const ButtonIcon = forwardRef<HTMLButtonElement, Props>(
  ({ icon, kind, shape, emphasis, size, onClick, disabled, cssClass, className, type = 'button' }, ref) => (
    <Box
      as="button"
      display="inline-flex"
      cssClass={clsx(styles.variants({ kind, shape, emphasis, size }), className, cssClass)}
      onClick={onClick}
      disabled={disabled}
      type={type}
      ref={ref}
    >
      {icon}
    </Box>
  ),
);
